import icon1 from './Assets/WebPage MVP_bg/icon1.png';
import icon2 from './Assets/WebPage MVP_bg/icon2.png';
import icon3 from './Assets/WebPage MVP_bg/icon3.png';

export const primary_card_info = [
    {
        "cardh": "Network",
        "cardp": "The Global Network of Students: A worldwide hub for students to connect, collaborate, and build valuable networks beyond borders. Join us in fostering global connections and expanding your network.",
        "cardIcon": "https://images.unsplash.com/photo-1632516643720-e7f5d7d6ecc9?q=80&w=3411&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
    },
    {
        "cardh": "Safety",
        "cardp": "Encr$#@%d Security&Privacy",
        "cardIcon": "https://images.unsplash.com/photo-1632516643720-e7f5d7d6ecc9?q=80&w=3411&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
    },
    {
        "cardh": "Convenience",
        "cardp": "ChatGPT based assistant, Automated Matching & search",
        "cardIcon": "https://images.unsplash.com/photo-1632516643720-e7f5d7d6ecc9?q=80&w=3411&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
    },
];

export const secondary_card_info = [
    {
        "cardh": "No Fake Accounts",
        "cardp": "No imposters who send the same unwanted Ad 100 times No more Pesky Ads in DM that are frustrating",
        "cardIcon": icon1
    },
    {
        "cardh": "No More Spam",
        "cardp": "Don’t loose your precious time in spam filled social media groups Forget infinite scrolling in those muted group chats filled with irrelevant texts",
        "cardIcon": icon2
    },
    {
        "cardh": "No Privacy Issues",
        "cardp": " Hey girl !! Yes you ! Take charge of your DM. Choose who can see your contact No more stress of blocking creepy freaks from the public groups that bother you in DM",
        "cardIcon": icon3
    },
];